import './App.css';
import About from './components/About';
import Navbar from './components/Navbar';
import Textforms from './components/Textforms';
import React, { useState } from 'react';
import Alert from './components/Alert';
// import {
//     BrowserRouter as Router,
//     Switch,
//     Route,
//     Link
//   } from "react-router-dom";


function App() {
    const[mode, setMode] = useState('light');
    const toggleMode = ()=>{
        if(mode === 'light'){
          setMode('dark');
          document.body.style.backgroundColor = '#042743';
          showAlert("Dark Mode has been enabled","success");
          document.title = 'eSKIMo - Dark';

        //   for flashes :
        //   setInterval(()=> {
        //     document.title = 'Install eSKIMo';
        //     }, 1500);
        }
        else{ 
        setMode('light');
        document.body.style.backgroundColor = 'white';
        showAlert("Light Mode has been enabled","success");
        }
    }
    const [alert, setAlert] = useState(null)
    const showAlert = (message, type)=>{
        setAlert({
        msg: message,
        type: type
        })
        setTimeout(() => {
            setAlert(null);
        }, 3000);
        }
    // const alert2 ="Feel free to checkout my GitHub for suggestions and contributions."
    return (
        <>
            <Navbar title="eSKIMo" aboutText="About eSKIMo" mode={mode} toggleMode={toggleMode} />
            <Alert alert={alert}/>
            <div className="container"><Textforms showAlert={showAlert} heading="Enter the text which you want to Labelize📜"mode={mode} /></div>
            <div className='container my-5'><About mode={mode}/></div>
            {/* <Alert alert="Feel free to checkout my GitHub for suggestions and contributions"/>  */}
            {/* <Alert alert={alert2}/> */}

        </>

    );
}

export default App;
